import DOMPurify from "dompurify";

// extract text content from html string
export function extractContent(text) {
    var span = document.createElement('span');
    span.innerHTML = text || '';
    return span ? span.textContent || span.innerText : '';
};

// convert string to html
export function createMarkup(data){
    const modifed = data?.replace(/text-align: right/g,"text-align: right;direction: rtl");
    return {
        __html: DOMPurify.sanitize(modifed)
    };
};

export const getLocalizedText = (defaultText, arabicText,isRTL) => {
    return isRTL === 'ar' ? (arabicText || defaultText) : defaultText;
};